import React, {useState, useContext, useRef, useEffect} from 'react'
import { useIonRouter, IonInput, IonButton, IonItem, IonList,IonGrid, IonRow, IonCol, IonModal, IonContent, IonLoading, IonIcon } from '@ionic/react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { eye, eyeOff } from 'ionicons/icons';

//import { Plugins } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences'
import Cookie from 'universal-cookie';

import { NativeBiometric } from "capacitor-native-biometric";
import { BiometryType } from "capacitor-native-biometric";

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { ClockIn_ClockOut_Modal } from '../../hotel/merchant/components/Modal_ClockIn_ClockOut';
import { Reset_Password_Modal } from './ResetPasswordModal';

import '../../css/layout.css';

//const { Storage } = Plugins;
let cookies = new Cookie();


async function removeStorageCredentials() {

    //alert("IN REMOVE CREDENTIALS - LOGIN");

    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'session' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });

    //let remove_cookie = null;

    //cookies.remove('session', remove_cookie);


}

async function setStorageCredentials_admin(event) {

    //alert('In setStorageCredentials_admin');
    //alert(event);

    Preferences.set({
        key: 'accountID',
        value: event[0],
    })
    Preferences.set({
        key: 'schemaName',
        value: event[1],
    })
    Preferences.set({
        key: 'isAuthenticated',
        value: event[2],
    })
    // Preferences.set({
    //     key: 'accessRights',
    //     value: [event[3], event[4], event[5], event[6],  event[7]],
    // })
    Preferences.set({
        key: 'loginUsername_authenticated',
        value: event[8],
    })
    Preferences.set({
        key: 'loginPassword_authenticated',
        value: event[9],
    })
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value:  JSON.stringify(event[10]),
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value:  JSON.stringify(event[11]),
    })
    Preferences.set({
        key: 'device',
        value: event[12],
    })

}

function setStorageCredentials_employee(event) {

    // alert('In setStorageCredentials_employee');
    // alert(event);
    // alert(event[7]);
    // alert(event[8]);
    //alert(event[9]);
    //alert(event[10]);
    //alert(event[11]);
    //alert([event[7], event[8], event[9], event[10],  event[11]].toString());

    Preferences.set({
        key: 'accountID',
        value: event[0],
    })
    Preferences.set({
        key: 'employeeID',
        value: event[1],
    })
    Preferences.set({
        key: 'employee_first_name',
        value: event[2],
    })
    Preferences.set({
        key: 'employee_last_name',
        value: event[3],
    })
    Preferences.set({
        key: 'employee_company',
        value: event[4],
    })



    Preferences.set({
        key: 'schemaName',
        value: event[5],
    })
    Preferences.set({
        key: 'isAuthenticated',
        value: event[6] ,
    })
    // Preferences.set({
    //     key: 'accessRights',
    //     value: [event[7], event[8], event[9], event[10],  event[11]].toString(),
    // })
    Preferences.set({
        key: 'loginUsername_authenticated',
        value: event[7],
    })
    Preferences.set({
        key: 'loginPassword_authenticated',
        value: event[8],
    })
    Preferences.set({
        key: 'employee_createdBy',
        value: event[9],
    })
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[10],
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value: event[11],
    })
    Preferences.set({
        key: 'device',
        value: event[12],
    })
}

function setStorageCredentials_employee_biometrics(event) {

    //alert('In setStorageCredentials_employee');
    //alert(event);
    //alert(event[7]);
    //alert(event[8]);
    //alert(event[9]);
    //alert(event[10]);
    //alert(event[11]);
    //alert([event[7], event[8], event[9], event[10],  event[11]].toString());
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[0],
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value: event[1],
    })
    Preferences.set({
        key: 'device',
        value: event[2],
    })
}

function setStorageCredentials_company(event) {



    // Preferences.set({
    //     key: 'capability',
    //     value: [event[0], event[1], event[2], event[3],  event[4], event[5]].toString(),
    // })

    Preferences.set({
        key: 'capability',
        value: JSON.stringify({
            basic: event[0],
            hotel: event[1],
            employee: event[2],
            proService: event[3],
            retail: event[4],
            jobs: event[5],
        })
    })

    // Preferences.set({
    //     key: 'feature',
    //     value: [event[0], event[1], event[2]].toString(),

    // })

    Preferences.set({
        key: 'feature',
        value: JSON.stringify({
            employeeHR: event[6],
            jobs: event[7],
        })
    })
}

function setStorageCredentials_accessRights(event) {

    Preferences.set({
        key: 'accessRights',
        value: [event[0], event[1], event[2], event[3],  event[4]].toString(),
    })

}
function setFunction_phoneNumber(event) {

    Preferences.set({
        key: 'company_phoneNumber',
        value: event[0],
    })
    Preferences.set({
        key: 'mtnCompany_phoneNumber',
        value: event[1],
    })

}

function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

function setFunction_subscription(event) {

    Preferences.set({
        key: 'subscription',
        //value: event,
        value: JSON.stringify({
            globalID: event[0],
            employeeID: event[1],
            subscriptionID: event[2],
            payAmount: event[3],
            currency: event[4],
            payStatus: event[5],
            payMethod: event[6],
            transactionReference: event[7],
            paymentDate: event[8],
            nextBillingDate: event[9],
            createdAt: event[10],
            updatedAt: event[11],
            transactionTotal: event[12],

        })

    })

}

// function setFunction_accounts_merchant(event) {

//     Preferences.set({
//         key: 'accounts_merchant',
//         //value: event,
//         value: JSON.stringify({
//             id: event[0],
//             merchantName: event[1],
//             username: event[2],
//             password: event[3],
//         })

//     })

// }

// function setFunction_accounts_user(event) {

//     Preferences.set({
//         key: 'accounts_user',
//         //value: event,
//         value: JSON.stringify({
//             id: event[0],
//             customerName: event[1],
//             username: event[2],
//             password: event[3],
//         })

//     })

// }


function setCookie(event) {

    // alert(event);
    // alert(event[1].cookie);
    // alert(JSON.stringify(event[1]));


    Preferences.set({
        key: 'session',
        value: JSON.stringify({
            user_sid: event[0],
            cookie: event[1].cookie,
        }),
      });
}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

function storeCredentials(event) {

    alert("Inside Store Credential function");
    alert(event[0])
    alert(event[1])

    try {
    NativeBiometric.setCredentials({
        username: event[0],
        password: event[1],
        server: 'ghanaverifiedtest.com', // Replace with your server/domain
      });
      alert('Credentials stored successfully.');
    } catch (error) {
    alert('Failed to store credentials:', error);
    }
  }


function retrieveCredentials() {

    alert("Inside rETRIEVE Credential function");

    try {
      const credentials = NativeBiometric.getCredentials({
        server: 'ghanaverifiedtest.com', // Match the server used in setCredentials
      });
  
      alert('Retrieved credentials:');
      alert(`Username: ${credentials.username}`);
      alert(`Password: ${credentials.password}`);


      return credentials;

    } catch (error) {
      console.error('Failed to retrieve credentials:', error);
    }
  }

export function MerchantLoginCredentials (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [loginUsername, setLoginUsername ] = useState('');
    let [loginPassword, setLoginPassword ] = useState('');
    let [showPassword, setShowPassword] = useState(false);

    let [acctID, setAccountID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);

    let [isbiometric_fingerprint_available, setIsBiometric_fingerprintAvilable] = useState(authenticatedMerchent_context.isBiometric_fingerprintAvilable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authenticatedMerchent_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authenticatedMerchent_context.device);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [storeCredentials_biometric, setStoreCredentials_biometric] = useState(false);

    let [landingPage, setLandingPage] = useState();

    let [viewClockInModalClockOut, setClockInClockOutModal] = useState(false);

    let [viewResetPasswordModal, setResetPasswordModal] = useState(false);

    let [fingerprintCancelled, setFingerprintCancelled] = useState(true);

    let [authCheckReady, setAuthCheckReady] = useState(false);

    let [isloading, setLoading] = useState(false);

    let history = useHistory();
    let router = useIonRouter();


    const usernameChangeHandler = (event) => {
        event.preventDefault();
        setLoginUsername(event.target.value);
    }

    const passwordChangeHandler = (event) => {
        event.preventDefault();
        setLoginPassword(event.target.value);
    }


    function handleConfirmEmployeeLogin_mobile(e) {

        //  alert("in Handle confirmEmployeeLogin - before preventdefault");
        //  alert(e);
        // alert(authenticatedMerchent_context.device);
        // alert(e[1]);
        // alert(e[2]);
        // alert(loginUsername);
        // alert(loginUsername);

        setLoading(true);
        
        let line7_authenticated;







        /*let formData = new FormData();


        formData.append('Tracker', '71000');
        formData.append('xUsername', loginUsername);
        formData.append('xPassword', loginPassword);*/
        if(authenticatedMerchent_context.device == 'mobile')
        {
            // alert("NEED TO VERIFY");
            // alert(e[1]);
            // alert(e[2]);

            if(fingerprintCancelled == false)
            {
                    NativeBiometric.verifyIdentity({
                        reason: "Setup - Fingerprint",
                        title: "Biometric Setup",
                        subtitle: "Authenticate to continue",
                        description: "Place your finger on the sensor",
                    }).then(() => {


                        //alert('INSIDE FINGERPRINT 1');


                            let fetch_body = "";


                            if(e[0] == "verify_mobile")
                            {
                                
                                if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'switch_accounts' || props.data.source == 'online_application_register_completed')
                                {
                                    fetch_body = {
                                        Tracker: '71000',
                                        xUsername: e[1].trim(),
                                        xPassword: e[2].trim(),
                                    };
                                }
                                else
                                {
                                    fetch_body = {
                                        Tracker: '71000',
                                        xUsername: e[1].trim(),
                                        xPassword: e[2].trim(),
                                    };
                                }
                        
                            }
                            else if (e[0] == 'setup_mobile')
                            {

                                if((loginUsername.trim().length === 0 || loginPassword.trim().length === 0) && (e[1].trim().length === 0 || e[2].trim().length === 0))
                                {
                                    return;
                                }
                        
                                // if(storeCredentials_biometric == true)
                                // {

                                //     alert("Inside Store Credential is true");
                                //     alert(loginUsername);
                                //     alert(loginPassword)

                                //     storeCredentials([loginUsername, loginPassword]);
                                // }

                                if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'switch_accounts' || props.data.source == 'online_application_register_completed')
                                {
                                    fetch_body = {
                                        Tracker: '71000',
                                        xUsername: e[1].trim(),
                                        xPassword: e[2].trim(),
                                    };
                                }
                                else
                                {
                                    fetch_body = {
                                        Tracker: '71000',
                                        xUsername: loginUsername.trim(),
                                        xPassword: loginPassword.trim(),
                                    };
                                }
                        
                            }

                            //alert('INSIDE FINGERPRINT 2');
                            // alert(JSON.stringify(fetch_body));
                            //alert(baseURL);

                            fetch(baseURL+'merchants_argsApp', {
                            method: 'POST',
                            credentials: 'include',
                            //mode: 'no-cors',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                //'content-type': 'text/html',
                                //'Access-Control-Allow-Origin':'*',
                                //'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS',
                                //'content-type': 'application/x-www-form-urlencoded',
                                //'cookie': 'cookie',
                            },
                            body: JSON.stringify(fetch_body)})
                            .then(res => res.json())
                            .then(res => {

                                //alert('INSIDE FINGERPRINT 3');
                            //alert(res);

                            const trimmedOutput = res.out.trim();
                            //alert(trimmedOutput);

                            if(trimmedOutput == "NULL")
                            {
                                alert('INCORRECT PASSWORD OR USERNAME. PLEASE TRY AGAIN.');
                                setLoading(false);
                            }

                                        let rows = res.out.toString().split('~~~');
                                        let lines = rows[0].split('|');
                                        let lines2 = rows[1].split('|');
                                        let lines3 = rows[2].split('|');
                                        let lines4 = rows[3].split('|');

                                        // let lines5 = rows[4].split('|');
                                        // let lines6 = rows[5].split('|');



                                                if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                                                {

                                                    //setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7], lines[8], lines[9], lines[10], lines[11], lines[12], loginUsername, loginPassword, lines[13]])
                                                    if(e[0] == "verify_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], e[1], e[2], lines[6]]);
                                                    if(e[0] == "setup_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], loginUsername, loginPassword, lines[6]]);

                                                    setCookie([res.id.toString(), res.cookies]);
                                                    setFunction_phoneNumber([lines[9], lines[10]]);

                                                    setStorageCredentials_sessionID(res.id.toString());

                                                    setStorageCredentials_company([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5], lines2[6], lines2[7]]);

                                                    setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
                                                    setFunction_subscription([lines4[0], lines4[1], lines4[2], lines4[3], lines4[4], lines4[5], lines4[6], lines4[7], lines4[8], lines4[9], lines4[10], lines4[11], lines4[12]]);

                                                    // setFunction_accounts_merchant([lines5[0], lines5[1], lines5[2], lines5[3]]);
                                                    // setFunction_accounts_user([lines6[0], lines6[1], lines6[2], lines6[3]]);

                                                    setStorageCredentials_employee_biometrics(['yes', 'yes', 'mobile'])

                                                    if(e[0] == "verify_mobile")
                                                    {
                                                        authenticatedMerchent_context.changeLoginUsername(e[1]);
                                                        authenticatedMerchent_context.changeLoginPassword(e[2]);
                                                    }

                                                    if(e[0] == "setup_mobile")
                                                    {
                                                        authenticatedMerchent_context.changeLoginUsername(loginUsername);
                                                        authenticatedMerchent_context.changeLoginPassword(loginPassword);
                                                    }


                                                    //setLoginUsername('');
                                                    //setLoginPassword('');

                                                    authenticatedMerchent_context.changeSessionID(res.id.toString());
                                                    authenticatedMerchent_context.changeSession(JSON.stringify({
                                                        user_sid: res.id.toString(),
                                                        cookie: res.cookies,
                                                    }));
                                                    authenticatedMerchent_context.changeAccountID(lines[1]);
                                                    authenticatedMerchent_context.changeEmployeeID(lines[2]);
                                                    authenticatedMerchent_context.changeEmployeeFirstName(lines[3]);
                                                    authenticatedMerchent_context.changeEmployeeLastName(lines[4]);
                                                    authenticatedMerchent_context.changeEmployeeCompany(lines[5]);

                                                    authenticatedMerchent_context.changeSchema(lines[8]);
                                                    authenticatedMerchent_context.changeBiometric_fingerprint('yes');

                                                    line7_authenticated = lines[7];

                                                    //authenticatedMerchent_context.changeAuthenticated(lines[7]);
                                                    //authenticatedMerchent_context.changeAccessRights([lines[8], lines[9], lines[10], lines[11], lines[12]]);

                                                    authenticatedMerchent_context.changeEmployeeCreatedBy(lines[8]);
                                                    authenticatedMerchent_context.changeCompanyPhoneNumber(lines[9]);

                                                    //authenticatedMerchent_context.changeCapability([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5]]);


                                                    //authenticatedMerchent_context.changeFeature([lines2[6], lines2[7]]);

                                                    authenticatedMerchent_context.changeCapability(JSON.stringify({
                                                        basic: lines2[0],
                                                        hotel: lines2[1],
                                                        employee: lines2[2],
                                                        proService: lines2[3],
                                                        retail: lines2[4],
                                                        jobs: lines2[5],
                                                    }));


                                                    authenticatedMerchent_context.changeFeature(JSON.stringify({
                                                        employeeHR: lines2[6],
                                                        jobs: lines2[7],
                                                    }));


                                                    let initialSetupParsed = {};
                
                                                    try {
                                                    initialSetupParsed = JSON.stringify({
                                                        setup_id: lines3[0],
                                                        details: lines3[1],
                                                        status: lines3[2],
                                                        dateCreated: lines3[3],
                                                        lastModified: lines3[4],
                                                    })
                                                        ? JSON.parse(JSON.stringify({
                                                            setup_id: lines3[0],
                                                            details: lines3[1],
                                                            status: lines3[2],
                                                            dateCreated: lines3[3],
                                                            lastModified: lines3[4],
                                                        })) : {};
                                    
                                                    if (typeof initialSetupParsed.details === 'string') {
                                                        initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
                                                    }
                                                    } catch (e) {
                                                    console.warn('Error parsing initialSetup:', e);
                                                    initialSetupParsed = {};
                                                    }
                                    
                                    
                                                 authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 

                                                
                                                    let subscriptionParsed = {};
                
                                                    try {
                                                    subscriptionParsed = JSON.stringify({
                                                       globalID: lines4[0],
                                                       employeeID: lines4[1],
                                                       subscriptionID: lines4[2],
                                                       payAmount: lines4[3],
                                                       currency: lines4[4],
                                                       payStatus: lines4[5],
                                                       payMethod: lines4[6],
                                                       transactionReference: lines4[7],
                                                       paymentDate: lines4[8],
                                                       nextBillingDate: lines4[9],
                                                       createdAt: lines4[10],
                                                       updatedAt: lines4[11],
                                                       transactionTotal: lines4[12],
                                                    })
                                                        ? JSON.parse(JSON.stringify({
                                                           globalID: lines4[0],
                                                           employeeID: lines4[1],
                                                           subscriptionID: lines4[2],
                                                           payAmount: lines4[3],
                                                           currency: lines4[4],
                                                           payStatus: lines4[5],
                                                           payMethod: lines4[6],
                                                           transactionReference: lines4[7],
                                                           paymentDate: lines4[8],
                                                           nextBillingDate: lines4[9],
                                                           createdAt: lines4[10],
                                                           updatedAt: lines4[11],
                                                           transactionTotal: lines4[12],
                                                        })) : {};
                                    
                                                    if (typeof subscriptionParsed.details === 'string') {
                                                        subscriptionParsed.details = JSON.parse(subscriptionParsed.details);
                                                    }
                                                    } catch (e) {
                                                    console.warn('Error parsing Subscription:', e);
                                                    subscriptionParsed = {};
                                                    }
                                    
                                    
                                                 authenticatedMerchent_context.changeSubscription(subscriptionParsed); 
   



                                           const requestOptions = {
                                                method: 'POST',
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify({
                                                        Tracker: '71000_accessRigts',
                                                        user: lines[1],
                                                        sessionID: res.id.toString(),
                                                    })
                                            }

                                                    fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                                    .then(res2 => res2.text())
                                                    .then(res2 => {
                                                        

                                                                let rows3 = res2.toString().split('~~~');
                                            
                                            
                                                                let lines3 = rows3[0].split('|');

                                            
                                                                setStorageCredentials_accessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]])
                                            
                                                                setLoading(false);

                                                                authenticatedMerchent_context.changeAccessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);

                                                                if((props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'online_application_register_completed') && (line7_authenticated=== 'T1' || line7_authenticated=== 'T2' || line7_authenticated=== 'T3' || line7_authenticated=== 'T4' || line7_authenticated=== 'C1'))
                                                                {
                                                                    //authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                                    props.closeModal(['REGISRATION_LOGIN_COMPLETED', line7_authenticated, lines[1], lines[8]]);
                                                                    props.payCloseModal(false);
                                                                }
                                                                else
                                                                {
                                                                    authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                                    setAuthCheckReady(true); // trigger effect to run
                                                                }
                                
                                            
                                                            })

                                                            //alert("Fingerprint Authentication Successful");

                                                }
                                                else
                                                {
                                                    alert('Incorrect Login or Password.  Please Try again');
                                                }

                                            })
                                            
                                    })
                                    .catch((error) => {

                                        //alert("ERROR : "+error);
                                        //alert("Fingerprint Authentication Failed");

                                        const errorMessage = error?.message || error;

                                        if (errorMessage.includes('Cancel')) {
                                            alert('FINGERPRINT CANCELED. PLEASE LOGIN');
                                            setFingerprintCancelled(true);
                                            setLoginUsername(null);
                                            setLoginPassword(null);
                                            setLoading(false);

                                        } else {
                                            alert('Fingerprint failed: ' + errorMessage);
                                            removeStorageCredentials();
                                            setLoading(false);
                                        }


                                        //removeStorageCredentials();
                                        //setLoading(false);

                                        
                                        //return Promise.resolve();

                                    })

                        }

                        
                        if(fingerprintCancelled == true)
                        {
                           //alert('INSIDE FINGERPRINT 1');
        
        
                                        setLoading(true);
                        
                                        let line7_authenticated;
                                
                                
                                
                                        if((loginUsername.trim().length === 0 || loginPassword.trim().length === 0) && (e[0].trim().length === 0 || e[1].trim().length === 0))
                                        {
                                            return;
                                        }
                                
                                
                                        /*let formData = new FormData();
                                
                                
                                        formData.append('Tracker', '71000');
                                        formData.append('xUsername', loginUsername);
                                        formData.append('xPassword', loginPassword);*/
                                
                                
                                        let fetch_body = "";
                                
                                        if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'switch_accounts' || props.data.source == 'online_application_register_completed')
                                        {
                                            fetch_body = {
                                                Tracker: '71000',
                                                xUsername: e[1].trim(),
                                                xPassword: e[2].trim(),
                                            };
                                        }
                                        else
                                        {
                                            fetch_body = {
                                                Tracker: '71000',
                                                xUsername: loginUsername.trim(),
                                                xPassword: loginPassword.trim(),
                                            };
                                        }
                                
                                        console.log(fetch_body);
                                    //alert('INSIDE FINGERPRINT 2');
                                    // alert(JSON.stringify(fetch_body));
                                    //alert(baseURL);
        
                                    fetch(baseURL+'merchants_argsApp', {
                                    method: 'POST',
                                    credentials: 'include',
                                    //mode: 'no-cors',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        //'content-type': 'text/html',
                                        //'Access-Control-Allow-Origin':'*',
                                        //'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS',
                                        //'content-type': 'application/x-www-form-urlencoded',
                                        //'cookie': 'cookie',
                                    },
                                    body: JSON.stringify(fetch_body)})
                                    .then(res => res.json())
                                    .then(res => {
        
                                        //alert('INSIDE FINGERPRINT 3');
                                    //alert(res);
        
                                    const trimmedOutput = res.out.trim();
                                    //alert(trimmedOutput);
        
                                    if(trimmedOutput == "NULL")
                                    {
                                        alert('INCORRECT PASSWORD OR USERNAME. PLEASE TRY AGAIN.');
                                        setLoading(false);
                                    }
        
                                                let rows = res.out.toString().split('~~~');
                                                let lines = rows[0].split('|');
                                                let lines2 = rows[1].split('|');
                                                let lines3 = rows[2].split('|');
                                                let lines4 = rows[3].split('|');

                                                // let lines5 = rows[4].split('|');
                                                // let lines6 = rows[5].split('|');

        
                                                        if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                                                        {
        
                                                            //setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7], lines[8], lines[9], lines[10], lines[11], lines[12], loginUsername, loginPassword, lines[13]])
                                                            if(e[0] == "verify_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], e[1], e[2], lines[6]]);
                                                            if(e[0] == "setup_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], loginUsername, loginPassword, lines[6]]);
        
                                                            setCookie([res.id.toString(), res.cookies]);
                                                            setFunction_phoneNumber([lines[9], lines[10]]);
        
                                                            setStorageCredentials_sessionID(res.id.toString());
        
                                                            setStorageCredentials_company([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5], lines2[6], lines2[7]])
        
                                                            setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
                                                            setFunction_subscription([lines4[0], lines4[1], lines4[2], lines4[3], lines4[4], lines4[5], lines4[6], lines4[7], lines4[8], lines4[9], lines4[10], lines4[11], lines4[12]]);


                                                            setStorageCredentials_employee_biometrics(['yes', 'yes', 'mobile'])
        
                                                            if(e[0] == "verify_mobile")
                                                            {
                                                                authenticatedMerchent_context.changeLoginUsername(e[1]);
                                                                authenticatedMerchent_context.changeLoginPassword(e[2]);
                                                            }
        
                                                            if(e[0] == "setup_mobile")
                                                            {
                                                                authenticatedMerchent_context.changeLoginUsername(loginUsername);
                                                                authenticatedMerchent_context.changeLoginPassword(loginPassword);
                                                            }
        
        
                                                            //setLoginUsername('');
                                                            //setLoginPassword('');
        
                                                            authenticatedMerchent_context.changeSessionID(res.id.toString());
                                                            authenticatedMerchent_context.changeSession(JSON.stringify({
                                                                user_sid: res.id.toString(),
                                                                cookie: res.cookies,
                                                            }));
                                                            authenticatedMerchent_context.changeAccountID(lines[1]);
                                                            authenticatedMerchent_context.changeEmployeeID(lines[2]);
                                                            authenticatedMerchent_context.changeEmployeeFirstName(lines[3]);
                                                            authenticatedMerchent_context.changeEmployeeLastName(lines[4]);
                                                            authenticatedMerchent_context.changeEmployeeCompany(lines[5]);
        
                                                            authenticatedMerchent_context.changeSchema(lines[8]);
                                                            authenticatedMerchent_context.changeBiometric_fingerprint('yes');
        
                                                            line7_authenticated = lines[7];
        
                                                            //authenticatedMerchent_context.changeAuthenticated(lines[7]);
                                                            //authenticatedMerchent_context.changeAccessRights([lines[8], lines[9], lines[10], lines[11], lines[12]]);
        
                                                            authenticatedMerchent_context.changeEmployeeCreatedBy(lines[8]);
                                                            authenticatedMerchent_context.changeCompanyPhoneNumber(lines[9]);
        
                                                            //authenticatedMerchent_context.changeCapability([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5]]);
        
        
                                                            //authenticatedMerchent_context.changeFeature([lines2[6], lines2[7]]);
        
                                                            authenticatedMerchent_context.changeCapability(JSON.stringify({
                                                                basic: lines2[0],
                                                                hotel: lines2[1],
                                                                employee: lines2[2],
                                                                proService: lines2[3],
                                                                retail: lines2[4],
                                                                jobs: lines2[5],
                                                            }));
        
        
                                                            authenticatedMerchent_context.changeFeature(JSON.stringify({
                                                                employeeHR: lines2[6],
                                                                jobs: lines2[7],
                                                            }));


                                                            let initialSetupParsed = {};
                
                                                            try {
                                                            initialSetupParsed = JSON.stringify({
                                                                setup_id: lines3[0],
                                                                details: lines3[1],
                                                                status: lines3[2],
                                                                dateCreated: lines3[3],
                                                                lastModified: lines3[4],
                                                            })
                                                                ? JSON.parse(JSON.stringify({
                                                                    setup_id: lines3[0],
                                                                    details: lines3[1],
                                                                    status: lines3[2],
                                                                    dateCreated: lines3[3],
                                                                    lastModified: lines3[4],
                                                                })) : {};
                                            
                                                            if (typeof initialSetupParsed.details === 'string') {
                                                                initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
                                                            }
                                                            } catch (e) {
                                                            console.warn('Error parsing initialSetup:', e);
                                                            initialSetupParsed = {};
                                                            }
                                            
                                            
                                                         authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 
        

                                                         let subscriptionParsed = {};
                
                                                         try {
                                                         subscriptionParsed = JSON.stringify({
                                                            globalID: lines4[0],
                                                            employeeID: lines4[1],
                                                            subscriptionID: lines4[2],
                                                            payAmount: lines4[3],
                                                            currency: lines4[4],
                                                            payStatus: lines4[5],
                                                            payMethod: lines4[6],
                                                            transactionReference: lines4[7],
                                                            paymentDate: lines4[8],
                                                            nextBillingDate: lines4[9],
                                                            createdAt: lines4[10],
                                                            updatedAt: lines4[11],
                                                            transactionTotal: lines4[12],
                                                         })
                                                             ? JSON.parse(JSON.stringify({
                                                                globalID: lines4[0],
                                                                employeeID: lines4[1],
                                                                subscriptionID: lines4[2],
                                                                payAmount: lines4[3],
                                                                currency: lines4[4],
                                                                payStatus: lines4[5],
                                                                payMethod: lines4[6],
                                                                transactionReference: lines4[7],
                                                                paymentDate: lines4[8],
                                                                nextBillingDate: lines4[9],
                                                                createdAt: lines4[10],
                                                                updatedAt: lines4[11],
                                                                transactionTotal: lines4[12],
                                                             })) : {};
                                         
                                                         if (typeof subscriptionParsed.details === 'string') {
                                                             subscriptionParsed.details = JSON.parse(subscriptionParsed.details);
                                                         }
                                                         } catch (e) {
                                                         console.warn('Error parsing Subscription:', e);
                                                         subscriptionParsed = {};
                                                         }
                                         
                                         
                                                      authenticatedMerchent_context.changeSubscription(subscriptionParsed); 
                
                                                            const requestOptions = {
                                                                method: 'POST',
                                                                headers: {
                                                                    'Accept': 'application/json',
                                                                    'Content-Type': 'application/json',
                                                                },
                                                                body: JSON.stringify({
                                                                        Tracker: '71000_accessRigts',
                                                                        user: lines[1],
                                                                        sessionID: res.id.toString(),
                                                                    })
                                                            }
        
        
                                                            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                                            .then(res2 => res2.text())
                                                            .then(res2 => {
                                                                
                                                                //alert("IN AUTHENTICATED 1");

                                                                        let rows3 = res2.toString().split('~~~');
                                                    
                                                                        //alert("IN AUTHENTICATED 2");

                                                                        let lines3 = rows3[0].split('|');
        
                                                    
                                                                        setStorageCredentials_accessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]])
                                                    
                                                                        setLoading(false);
                                                                        //alert("IN AUTHENTICATED 3");

                                                                        authenticatedMerchent_context.changeAccessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
        
                                                                        if((props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'online_application_register_completed') && (line7_authenticated=== 'T1' || line7_authenticated=== 'T2' || line7_authenticated=== 'T3' || line7_authenticated === 'T4' || line7_authenticated=== 'C1'))
                                                                        {
                                                                            //authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                                            props.closeModal(['REGISRATION_LOGIN_COMPLETED', line7_authenticated, lines[1], lines[8]]);
                                                                            props.payCloseModal(false);
                                                                        }
                                                                        else
                                                                        {
                                                                            authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                                            setAuthCheckReady(true); // trigger effect to run
                                                                        }
                                        
                                                    
                                                                    })
        
                                                                    //alert("Fingerprint Authentication Successful");
        
                                                        }
                                                        else
                                                        {
                                                            alert('Incorrect Login or Password.  Please Try again');
                                                        }
        
                                                    })
                                                    
        
                        }

            }

    }

    function handleConfirmEmployeeLogin(e) {

        //  alert("in Handle confirmEmployeeLogin - before preventdefault");
        //  alert(e);
        //  alert(e[0]);
        //  alert(e[1]);
        //e.preventDefault();

        setLoading(true);
        
        let line7_authenticated;



        if((loginUsername.trim().length === 0 || loginPassword.trim().length === 0) && (e[0].trim().length === 0 || e[1].trim().length === 0))
        {
            return;
        }


        /*let formData = new FormData();


        formData.append('Tracker', '71000');
        formData.append('xUsername', loginUsername);
        formData.append('xPassword', loginPassword);*/


        let fetch_body = "";

        if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'switch_accounts' || props.data.source == 'online_application_register_completed')
        {
            fetch_body = {
                Tracker: '71000',
                xUsername: e[0].trim(),
                xPassword: e[1].trim(),
            };
        }
        else
        {
            fetch_body = {
                Tracker: '71000',
                xUsername: loginUsername.trim(),
                xPassword: loginPassword.trim(),
            };
        }

        console.log(fetch_body);

        fetch(baseURL+'merchants_argsApp', {
          method: 'POST',
          credentials: 'include',
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //'content-type': 'text/html',
            //'Access-Control-Allow-Origin':'*',
            //'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS',
            //'content-type': 'application/x-www-form-urlencoded',
            //'cookie': 'cookie',
        },
        body: JSON.stringify(fetch_body)})
        .then(res => res.json())
        .then(res => {
            
                //alert(res);

            const trimmedOutput = res.out.trim();

            if(trimmedOutput == "NULL")
            {
                alert('INCORRECT PASSWORD OR USERNAME. PLEASE TRY AGAIN.');
                setLoading(false);
            }

                    let rows = res.out.toString().split('~~~');
                    let lines = rows[0].split('|');
                    let lines2 = rows[1].split('|');
                    let lines3 = rows[2].split('|');
                    let lines4 = rows[3].split('|');

                    // let lines5 = rows[4].split('|');
                    // let lines6 = rows[5].split('|');




                            if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                            {


                                if(authenticatedMerchent_context.device == 'desktop' || authenticatedMerchent_context.device == null)
                                {
                                    
    
    
                                //setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7], lines[8], lines[9], lines[10], lines[11], lines[12], loginUsername, loginPassword, lines[13]])
                                setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], loginUsername, loginPassword, lines[6]])
                                setCookie([res.id.toString(), res.cookies]);
                                setFunction_phoneNumber([lines[9], lines[10]]);

                                setStorageCredentials_sessionID(res.id.toString());

                                setStorageCredentials_company([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5], lines2[6], lines2[7]]);

                                setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
                                setFunction_subscription([lines4[0], lines4[1], lines4[2], lines4[3], lines4[4], lines4[5], lines4[6], lines4[7], lines4[8], lines4[9], lines4[10], lines4[11], lines4[12]]);
                                

                                authenticatedMerchent_context.changeLoginUsername(loginUsername);
    
                                authenticatedMerchent_context.changeLoginPassword(loginPassword);
    
                                setLoginUsername('');
                                setLoginPassword('');

                                authenticatedMerchent_context.changeSessionID(res.id.toString());
                                authenticatedMerchent_context.changeSession(JSON.stringify({
                                    user_sid: res.id.toString(),
                                    cookie: res.cookies,
                                }));
                                authenticatedMerchent_context.changeAccountID(lines[1]);
                                authenticatedMerchent_context.changeEmployeeID(lines[2]);
                                authenticatedMerchent_context.changeEmployeeFirstName(lines[3]);
                                authenticatedMerchent_context.changeEmployeeLastName(lines[4]);
                                authenticatedMerchent_context.changeEmployeeCompany(lines[5]);

                                authenticatedMerchent_context.changeSchema(lines[8]);
    
                                authenticatedMerchent_context.changeCompanyPhoneNumber(lines[9]);

                                line7_authenticated = lines[7];
    
                                //authenticatedMerchent_context.changeAuthenticated(lines[7]);
                                //authenticatedMerchent_context.changeAccessRights([lines[8], lines[9], lines[10], lines[11], lines[12]]);
    
                                authenticatedMerchent_context.changeEmployeeCreatedBy(lines[8]);
    
                                //authenticatedMerchent_context.changeCapability([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5]]);
    
    
                                //authenticatedMerchent_context.changeFeature([lines2[6], lines2[7]]);

                                authenticatedMerchent_context.changeCapability(JSON.stringify({
                                    basic: lines2[0],
                                    hotel: lines2[1],
                                    employee: lines2[2],
                                    proService: lines2[3],
                                    retail: lines2[4],
                                    jobs: lines2[5],
                                }));
    
    
                                authenticatedMerchent_context.changeFeature(JSON.stringify({
                                    employeeHR: lines2[6],
                                    jobs: lines2[7],
                                }));

                                let initialSetupParsed = {};
                
                                try {
                                initialSetupParsed = JSON.stringify({
                                    setup_id: lines3[0],
                                    details: lines3[1],
                                    status: lines3[2],
                                    dateCreated: lines3[3],
                                    lastModified: lines3[4],
                                })
                                    ? JSON.parse(JSON.stringify({
                                        setup_id: lines3[0],
                                        details: lines3[1],
                                        status: lines3[2],
                                        dateCreated: lines3[3],
                                        lastModified: lines3[4],
                                    })) : {};
                
                                if (typeof initialSetupParsed.details === 'string') {
                                    initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
                                }
                                } catch (e) {
                                console.warn('Error parsing initialSetup:', e);
                                initialSetupParsed = {};
                                }
                
                
                             authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 




                             let subscriptionParsed = {};
                
                             try {
                             subscriptionParsed = JSON.stringify({
                                globalID: lines4[0],
                                employeeID: lines4[1],
                                subscriptionID: lines4[2],
                                payAmount: lines4[3],
                                currency: lines4[4],
                                payStatus: lines4[5],
                                payMethod: lines4[6],
                                transactionReference: lines4[7],
                                paymentDate: lines4[8],
                                nextBillingDate: lines4[9],
                                createdAt: lines4[10],
                                updatedAt: lines4[11],
                                transactionTotal: lines4[12],
                             })
                                 ? JSON.parse(JSON.stringify({
                                    globalID: lines4[0],
                                    employeeID: lines4[1],
                                    subscriptionID: lines4[2],
                                    payAmount: lines4[3],
                                    currency: lines4[4],
                                    payStatus: lines4[5],
                                    payMethod: lines4[6],
                                    transactionReference: lines4[7],
                                    paymentDate: lines4[8],
                                    nextBillingDate: lines4[9],
                                    createdAt: lines4[10],
                                    updatedAt: lines4[11],
                                    transactionTotal: lines4[12],
                                 })) : {};
             
                             if (typeof subscriptionParsed.details === 'string') {
                                 subscriptionParsed.details = JSON.parse(subscriptionParsed.details);
                             }
                             } catch (e) {
                             console.warn('Error parsing Subscription:', e);
                             subscriptionParsed = {};
                             }
             
             
                          authenticatedMerchent_context.changeSubscription(subscriptionParsed); 


    
                                const requestOptions = {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                            Tracker: '71000_accessRigts',
                                            user: lines[1],
                                            sessionID: res.id.toString(),
                                        })
                                }

                        
                                fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                .then(res2 => res2.text())
                                .then(res2 => {
                                    //alert("IN AUTHENTICATED 1");

                                            let rows3 = res2.toString().split('~~~');
                        
                                            //alert("IN AUTHENTICATED 2");

                                            let lines3 = rows3[0].split('|');


                                            setStorageCredentials_accessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]])
                                        // alert("IN AUTHENTICATED 3");
                                        // alert(props.data.source);
                                        //  alert(line7_authenticated);
                                        // alert(lines3);

                                            setLoading(false);
                        
                                            authenticatedMerchent_context.changeAccessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
                                    
                                            if((props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'online_application_register_completed') && (line7_authenticated=== 'T1' || line7_authenticated=== 'T2' || line7_authenticated=== 'T3' || line7_authenticated === 'T4' || line7_authenticated=== 'C1'))
                                            {
                                                //authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                                                        //alert("IN AUTHENTICATED 4");

                                                props.closeModal(['REGISRATION_LOGIN_COMPLETED', line7_authenticated, lines[1], lines[8]]);
                                                props.payCloseModal(false);
                                            }
                                            else
                                            {
                                                authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                                                setAuthCheckReady(true); // trigger effect to run
                                            }
            
                        
                                        })
    
                                }
    
                            }
                            else
                            {
                                alert('Incorrect Login or Password.  Please Try again');
                            }



                           
                })

    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    function handleLogin(e)
    {

        // alert("in Handle Login 1");
        // alert(props.data.source );
        // alert(authenticatedMerchent_context.device );

        if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'online_application_register_completed')
        {

            setLoginUsername(props.data.username);
            setLoginPassword(props.data.password);

            if(authenticatedMerchent_context.device == 'mobile')
            {
                handleConfirmEmployeeLogin_mobile(['verify_mobile', props.data.username, props.data.password]);
            }
            else
            {

                handleConfirmEmployeeLogin([props.data.username, props.data.password]);

            }
        }
        else
        {
            if(authenticatedMerchent_context.device == 'mobile')
            {
                handleConfirmEmployeeLogin_mobile(['setup_mobile', loginUsername, loginPassword]);
            }
            else
            {
                handleConfirmEmployeeLogin([loginUsername, loginPassword]);
            }
        }
    }

    useEffect(() => {

        // alert("IN MERCHANT LOGIN");
        // alert(props.data.source);
        // alert(props.data.username);
        // alert(props.data.password);

            if(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'switch_accounts' || props.data.source == 'online_application_register_completed')
            {

                setLoginUsername(props.data.username);
                setLoginPassword(props.data.password);

                if(authenticatedMerchent_context.device == 'mobile')
                {
                    handleConfirmEmployeeLogin_mobile(['verify_mobile', props.data.username, props.data.password]);
                }
                else
                {

                    handleConfirmEmployeeLogin([props.data.username, props.data.password]);

                }
            }
            else
            {
                const fetchData = async () => {
                    const username = (await Preferences.get({ key: 'loginUsername_authenticated' })).value;
                    const password = (await Preferences.get({ key: 'loginPassword_authenticated' })).value;
            

                // alert(cookies.get('session'))
                // alert(authenticatedMerchent_context.loginUsername)
                // alert(authenticatedMerchent_context.loginPassword)
                // alert(authenticatedMerchent_context.device)
                // alert(username)
                // alert(password)

                if(authenticatedMerchent_context.device == 'mobile')
                {

                    //alert("IN MERCHANT LOGIN USE EFFECT MOBILE");

                    setLoginUsername(username);
                    setLoginPassword(password);
                    //let credentials = retrieveCredentials();

                    //alert("CREDENTIALS");
                    //alert(credentials.username);
        
                    if(username == undefined)
                    {
                        //handleConfirmEmployeeLogin_mobile(['verify_mobile', username, password]);
                    }
                    else if(username != undefined)
                    {
                        handleConfirmEmployeeLogin_mobile(['verify_mobile', username, password]);
                        //setStoreCredentials_biometric(true);
                    }
                }
            }

            fetchData();

        }

    }, [])

    useEffect(() => {

        // alert("In login useEffect");
        // alert(authCheckReady);
        // alert(authenticatedMerchent_context.authenticated);

        if (!authCheckReady) return;
      
        const auth = authenticatedMerchent_context.authenticated;
      
        if (auth === 'T1') {
            router.push('/hotel_merchantMainPageApp', 'forward', 'replace');
        } else if (auth === 'T2') {
            router.push('/proService_merchantMainPageApp', 'forward', 'replace');
        } else if (auth === 'T3') {
            router.push('/retail_merchantMainPageApp', 'forward', 'replace');
        }else if (auth === 'T4') {
            router.push('/jobBoard_merchantMainPageApp', 'forward', 'replace');
        } else if (auth === 'C1') {
            router.push('/clientMainPageApp', 'forward', 'replace');
        }
      
        props.closeModal(false);
      
      }, [authenticatedMerchent_context.authenticated, authCheckReady]);


    //alert('in LoginCredential_merchant');
    //alert(landingPage)

    return (

             /*<React.Fragment>
                {authenticatedMerchent_context.authenticated == null && 
                    (<React.Fragment><IonInput id="merchantUsername" placeholder="Enter Username" value={loginUsername} onIonChange={usernameChangeHandler }></IonInput>
                    <IonInput id="merchantPassword" placeholder="Enter Password" value={loginPassword} onIonChange={passwordChangeHandler }></IonInput>
                    <IonButton slot="end" onClick={ handleConfirmMerchantLogin }>Admin Login</IonButton>
                    <IonButton slot="end" onClick={ handleConfirmEmployeeLogin }>Employee Login</IonButton></React.Fragment>)}

            </React.Fragment>*/
    

        <React.Fragment>

                <IonModal isOpen={ props.openModal }>

                        <IonGrid className='login_grid'>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonInput id="merchantUsername" placeholder="Enter Username" value={loginUsername} onIonChange={usernameChangeHandler }></IonInput>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonInput type={showPassword ? 'text' : 'password'} id="merchantPassword" placeholder="Enter Password" value={loginPassword} onIonChange={passwordChangeHandler }></IonInput><IonButton fill="clear" onClick={() => setShowPassword(!showPassword)} style={{ marginLeft: '5px' }}><IonIcon icon={showPassword ? eyeOff : eye} /></IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    {/*<button onClick={handleConfirmEmployeeLogin}>Login</button>*/}
                                     <IonButton onClick={(e) => handleLogin(e)}>Login</IonButton>
                                </IonCol>

                                {/*<IonCol size='6'>
                                    <IonButton onClick={ handleConfirmEmployeeLogin }>SetUp Fingerprint</IonButton>
                                </IonCol>*/}
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonButton onClick={() => setResetPasswordModal(true) }>Reset Password</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                    <ClockIn_ClockOut_Modal openModal={ viewClockInModalClockOut } closeModal={() => setClockInClockOutModal(false)}></ClockIn_ClockOut_Modal>

                    {viewResetPasswordModal && <Reset_Password_Modal openModal={ viewResetPasswordModal } closeModal={() => setResetPasswordModal(false)}></Reset_Password_Modal>}

                    {(props.data.source == 'online_pay_register_completed' || props.data.source == 'job_board_register_completed' || props.data.source == 'online_application_register_completed') && <IonButton onClick={() => props.payCloseModal(false)}>Close</IonButton>}
                    {(props.data.source != 'online_pay_register_completed' || props.data.source != 'job_board_register_completed' || props.data.source != 'online_application_register_completed') &&  <IonButton onClick={() => props.closeModal(false)}>Close</IonButton>}


                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                                
                </IonModal>
                   
        </React.Fragment>  
    )
     
}